import * as React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fab from "@mui/material/Fab";
import Typography from "@mui/material/Typography";

import { MaterialIcons } from "../../icons/Material/MaterialIcons";

type CustomCircularProgressType = {
  processingErrorMessage: string;
  isProcessingMessage: string;
  successIcon: boolean;
};

const CustomCircularProgress: React.FC<CustomCircularProgressType> = ({
  processingErrorMessage,
  isProcessingMessage,
  successIcon,
}) => {
  const { t } = useTranslation("common");
  const resolvedProcessingErrorMessage =
    processingErrorMessage ?? t("modals.genericErrorTitle");
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
    >
      <Box sx={{ m: 1, position: "relative" }}>
        <Fab aria-label="save" color={successIcon ? "success" : "error"}>
          {successIcon ? (
            <MaterialIcons.CheckIcon sx={{ fontSize: "42px" }} />
          ) : (
            <MaterialIcons.ErrorIcon sx={{ fontSize: "42px" }} />
          )}
        </Fab>
      </Box>
      <Typography sx={{ textAlign: "center", mt: 1 }}>
        {successIcon ? isProcessingMessage : resolvedProcessingErrorMessage}
      </Typography>

      {/* Tras un error el estado de la novedad puede haber cambiado (p.ej. ya
          procesada desde otra pestaña), por eso se recarga en vez de cerrar. */}
      {processingErrorMessage && (
        <Box sx={{ pt: 3 }}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => window.location.reload()}
          >
            {t("actions.reloadPage")}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default CustomCircularProgress;
